import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Chip from '@mui/material/Chip';
import { Translate, openFile, byteSize, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tour-extra-category.reducer';

const FieldLabel = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
    {children}
  </Typography>
);

const FieldValue = ({ children, sx }: { children: React.ReactNode; sx?: object }) => (
  <Typography variant="body1" sx={{ mb: 2, ...sx }}>
    {children || '-'}
  </Typography>
);

const BooleanDisplay = ({ value }: { value?: boolean }) =>
  value ? (
    <Chip icon={<FontAwesomeIcon icon="check" />} label="Yes" color="success" size="small" />
  ) : (
    <Chip icon={<FontAwesomeIcon icon="times" />} label="No" color="error" size="small" />
  );

export const TourExtraCategoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tourExtraCategoryEntity = useAppSelector(state => state.tourExtraCategory.entity);
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <h2 data-cy="tourExtraCategoryDetailsHeading">
          <Translate contentKey="jhipsterSampleApplicationApp.tourExtraCategory.detail.title">TourExtraCategory</Translate>
        </h2>
        {tourExtraCategoryEntity.id && (
          <Box sx={{ bgcolor: 'primary.light', color: 'primary.contrastText', px: 2, py: 0.5, borderRadius: 1, fontWeight: 'bold' }}>
            ID: {tourExtraCategoryEntity.id}
          </Box>
        )}
      </Box>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourExtraCategory.code" />
          </FieldLabel>
          <FieldValue>{tourExtraCategoryEntity.code}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourExtraCategory.enabled" />
          </FieldLabel>
          <BooleanDisplay value={tourExtraCategoryEntity.enabled} />

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourExtraCategory.icon" />
          </FieldLabel>
          <FieldValue>{tourExtraCategoryEntity.icon}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourExtraCategory.defaultImage" />
          </FieldLabel>
          <FieldValue>{tourExtraCategoryEntity.defaultImage}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourExtraCategory.defaultImageData" />
          </FieldLabel>
          {tourExtraCategoryEntity.defaultImageData ? (
            <Box sx={{ mb: 2 }}>
              {tourExtraCategoryEntity.defaultImageDataContentType ? (
                <a onClick={openFile(tourExtraCategoryEntity.defaultImageDataContentType, tourExtraCategoryEntity.defaultImageData)}>
                  <img
                    src={`data:${tourExtraCategoryEntity.defaultImageDataContentType};base64,${tourExtraCategoryEntity.defaultImageData}`}
                    style={{ maxHeight: '30px' }}
                  />
                </a>
              ) : null}
              <Typography variant="body2" color="text.secondary">
                {tourExtraCategoryEntity.defaultImageDataContentType}, {byteSize(tourExtraCategoryEntity.defaultImageData)}
              </Typography>
            </Box>
          ) : (
            <FieldValue>No image</FieldValue>
          )}

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourExtraCategory.shopCategoryId" />
          </FieldLabel>
          <FieldValue>{tourExtraCategoryEntity.shopCategoryId}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourExtraCategory.shopUrl" />
          </FieldLabel>
          <FieldValue>{tourExtraCategoryEntity.shopUrl}</FieldValue>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourExtraCategory.createdDate" />
          </FieldLabel>
          <FieldValue>
            {tourExtraCategoryEntity.createdDate ? (
              <TextFormat value={tourExtraCategoryEntity.createdDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourExtraCategory.createdBy" />
          </FieldLabel>
          <FieldValue>{tourExtraCategoryEntity.createdBy ? tourExtraCategoryEntity.createdBy.login : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourExtraCategory.extra" />
          </FieldLabel>
          <FieldValue>
            {tourExtraCategoryEntity.extras
              ? tourExtraCategoryEntity.extras.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.code}</a>
                    {tourExtraCategoryEntity.extras && i === tourExtraCategoryEntity.extras.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </FieldValue>
        </Grid>

        <Grid size={12}>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button
              component={Link}
              to="/tour-extra-category"
              replace
              color="info"
              variant="outlined"
              startIcon={<FontAwesomeIcon icon="arrow-left" />}
            >
              <Translate contentKey="entity.action.back">Back</Translate>
            </Button>
            <Button
              component={Link}
              to={`/tour-extra-category/${tourExtraCategoryEntity.id}/edit`}
              replace
              color="primary"
              variant="contained"
              startIcon={<FontAwesomeIcon icon="pencil-alt" />}
            >
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TourExtraCategoryDetail;
